import { createContext, useContext, useEffect, useState } from 'react';
import { apiClient } from '@/lib/apiClient';
import { getVendorSlugFromHostname } from '@/lib/subdomain';

const MarketplaceContext = createContext(null);

export function MarketplaceProvider({ children }) {
  const vendorSlug = getVendorSlugFromHostname(window.location.hostname);

  const [vendor, setVendor] = useState(null);
  const [state, setState] = useState(vendorSlug ? 'loading' : 'platform');

  useEffect(() => {
    if (!vendorSlug) {
      setVendor(null);
      setState('platform');
      return;
    }

    let cancelled = false;

    async function loadVendor() {
      setState('loading');

      const { data, error } = await apiClient.GET(
        '/api/v1/vendors/by-slug/{slug}',
        {
          params: {
            path: { slug: vendorSlug },
          },
        }
      );

      if (cancelled) return;

      if (error || !data) {
        setVendor(null);
        setState('not-found');
        return;
      }

      setVendor(data);
      setState('ready');
    }

    loadVendor();

    return () => {
      cancelled = true;
    };
  }, [vendorSlug]);

  return (
    <MarketplaceContext.Provider
      value={{
        vendor,
        vendorSlug,
        state,
        isVendorSubdomain: Boolean(vendorSlug),
      }}
    >
      {children}
    </MarketplaceContext.Provider>
  );
}

export function useMarketplace() {
  const context = useContext(MarketplaceContext);

  if (!context) {
    throw new Error('useMarketplace must be used inside MarketplaceProvider');
  }

  return context;
}